import { PRACTICAL_STREAM_CDN_ADDRESS, USE_CDN } from '../utilities/config'
import { HOST } from '../../pages/api/utils/config'

export const FIVE_MISTAKES_ARTICLE_TITLE: string =
  '5 Mistakes Businesses Make When Choosing Background Music (and How to Fix Them)'
export const FIVE_MISTAKES_ARTICLE_TITLE_ES: string =
  'Cinco errores que cometen las empresas al elegir música de fondo (y cómo corregirlos)'
export const FIVE_MISTAKES_ARTICLE_TITLE_FR: string =
  "Cinq erreurs que les entreprises commettent Lors du choix de la musique d'ambiance (et comment les corriger)"
export const FIVE_MISTAKES_ARTICLE_TITLE_KO: string =
  '기업들이 배경 음악을 선택할 때 저지르는 다섯 가지 실수 (그리고 해결 방법)'

export const FIVE_MISTAKES_TITLE_HTML: JSX.Element = (
  <>
    5 Mistakes Businesses Make When Choosing Background Music
    <br />
    (and&nbsp;How to&nbsp;Fix Them)
  </>
)
export const FIVE_MISTAKES_TITLE_HTML_ES: JSX.Element = (
  <>
    Cinco errores que cometen las empresas al elegir música de fondo
    <br />
    (y&nbsp;Cómo Corregirlos)
  </>
)
export const FIVE_MISTAKES_TITLE_HTML_FR: JSX.Element = (
  <>
    Cinq erreurs que les entreprises commettent lors du choix de la musique
    d'ambiance
    <br />
    (et&nbsp;comment les&nbsp;corriger)
  </>
)
export const FIVE_MISTAKES_TITLE_HTML_KO: JSX.Element = (
  <>
    <span aria-hidden={true} className={'atb'}>
      기업들이
    </span>{' '}
    <span className={'atb'} aria-hidden={true}>
      배경
    </span>{' '}
    <span className={'atb'} aria-hidden={true}>
      음악을
    </span>{' '}
    <span className={'atb'} aria-hidden={true}>
      선택할
    </span>{' '}
    <span className={'atb'} aria-hidden={true}>
      때
    </span>{' '}
    <span className={'atb'} aria-hidden={true}>
      저지르는
    </span>{' '}
    <span className={'atb'} aria-hidden={true}>
      다섯
    </span>{' '}
    <span className={'atb'} aria-hidden={true}>
      가지
    </span>{' '}
    <span className={'atb'} aria-hidden={true}>
      실수
    </span>{' '}
    <span className={'atb'} aria-hidden={true}>
      (그리고
    </span>{' '}
    <span className={'atb'} aria-hidden={true}>
      해결
    </span>{' '}
    <span className={'atb'} aria-hidden={true}>
      방법)
    </span>
  </>
)

export const FIVE_MISTAKES_PAGE_ID: string =
  '6787A61F-8BA3-4588-B51A-A6BED996CAD2'

export const FIVE_MISTAKES_ARTICLE_ROUTE: string =
  '/articles/five-mistakes-businesses-make'
export const FIVE_MISTAKES_ARTICLE_ROUTE_ES: string =
  '/articles/five-mistakes-businesses-make'
export const FIVE_MISTAKES_ARTICLE_ROUTE_FR: string =
  '/articles/five-mistakes-businesses-make'
export const FIVE_MISTAKES_ARTICLE_ROUTE_KO: string =
  '/articles/five-mistakes-businesses-make'

export const FIVE_MISTAKES_ARTICLE_URL: string =
  HOST + FIVE_MISTAKES_ARTICLE_ROUTE_ES
export const FIVE_MISTAKES_ARTICLE_URL_ES: string =
  HOST + '/es' + FIVE_MISTAKES_ARTICLE_ROUTE_ES
export const FIVE_MISTAKES_ARTICLE_URL_FR: string =
  HOST + '/fr' + FIVE_MISTAKES_ARTICLE_ROUTE_FR
export const FIVE_MISTAKES_ARTICLE_URL_KO: string =
  HOST + '/ko' + FIVE_MISTAKES_ARTICLE_ROUTE_KO

export const ARTICLE_KEYWORDS =
  'background music streaming, restaurant music strategy, background music mistakes, mistakes in retail music, optimizing business playlist, coffee shop background music, uplifting music for sales, bmp for restaurant music, romantic dinner ambiance, diner music playlists, customer experience sound design, curated business playlist 2026, audio branding for hospitality, music tempo and pacing for business, cafe atmosphere optimization, improving restaurant sales, commercial music licensing, hospitality sound design, business background music, ambient music, licensed music, music for restaurants, music for retail, practical stream'
export const ARTICLE_KEYWORDS_ES =
  'Música de fondo en streaming, estrategia musical para restaurantes, errores en la música de fondo, errores en la música para comercios, optimización de listas de reproducción para negocios, música de fondo para cafeterías, música motivadora para ventas, BPM para música de restaurantes, ambiente romántico para cenas, listas de reproducción para restaurantes, diseño de sonido para la experiencia del cliente, listas de reproducción seleccionadas para negocios 2026, branding sonoro para el sector hotelero, tempo y ritmo musical para negocios, optimización del ambiente de cafeterías, mejora de las ventas en restaurantes, licencias de música comercial, diseño de sonido para hostelería, música de fondo para negocios, música ambiental, música con licencia, música para restaurantes, música para comercios, practical stream'
export const ARTICLE_KEYWORDS_FR =
  "diffusion de musique d'ambiance, stratégie musicale pour restaurants, erreurs en matière de musique d'ambiance, erreurs dans la musique en magasin, optimisation des playlists commerciales, musique d'ambiance pour cafés, musique entraînante pour stimuler les ventes, BPM pour la musique de restaurant, ambiance romantique pour dîner, playlists musicales pour restaurants, conception sonore de l'expérience client, playlists commerciales sélectionnées 2026, identité sonore pour l'hôtellerie, tempo et rythme musical pour les entreprises, optimisation de l'atmosphère des cafés, amélioration des ventes des restaurants, licences de musique commerciale, conception sonore pour l'hôtellerie-restauration, musique d'ambiance pour entreprises, musique d'ambiance, musique sous licence, musique pour restaurants, musique pour commerces de détail, practical stream"
export const ARTICLE_KEYWORDS_KO =
  '배경 음악 스트리밍, 레스토랑 음악 전략, 배경 음악 관련 실수, 소매점 음악 관련 실수, 비즈니스 플레이리스트 최적화, practical stream'

export const ARTICLE_IMAGE_AVIF: string = USE_CDN
  ? PRACTICAL_STREAM_CDN_ADDRESS + 'D58746A7-ED64-4181-B6D8-EF562CF40733.avif'
  : HOST + '/images/D58746A7-ED64-4181-B6D8-EF562CF40733.avif'
export const ARTICLE_IMAGE_JPEG: string = USE_CDN
  ? PRACTICAL_STREAM_CDN_ADDRESS + 'D58746A7-ED64-4181-B6D8-EF562CF40733.jpg'
  : HOST + '/images/D58746A7-ED64-4181-B6D8-EF562CF40733.jpg'
export const OPEN_GRAPH_IMAGE_JPEG: string = USE_CDN
  ? PRACTICAL_STREAM_CDN_ADDRESS + '8EBD782E-C8A9-4164-A8D6-ACFE34746CF9.jpg'
  : HOST + '/images/8EBD782E-C8A9-4164-A8D6-ACFE34746CF9.jpg'

export const FIVE_MISTAKES_JSON_LD_IMAGE_1200_X_1200: string = USE_CDN
  ? PRACTICAL_STREAM_CDN_ADDRESS + 'F1905ECD-CDCF-43AC-90A7-6B5243409AE0.png'
  : HOST + '/images/F1905ECD-CDCF-43AC-90A7-6B5243409AE0.png'

export const ARTICLE_SUMMARY: string =
  'When it comes to music for business, it is not what you serve but what you play. However, the vast majority of businesses commit critical mistakes, costing them clients, income, and, in certain instances, tens of thousands in legal fines. In this article, we analyze the five most expensive business playlist mistakes and see how they can be fixed before they damage your bottom line.'
export const ARTICLE_SUMMARY_ES: string =
  'Cuando se trata de música para negocios, lo importante no es lo que ofreces, sino lo que reproduces. Sin embargo, la gran mayoría de las empresas cometen errores graves que les cuestan clientes, ingresos y, en algunos casos, decenas de miles de dólares en multas legales. En este artículo, analizamos los cinco errores más costosos al crear listas de reproducción para negocios y cómo solucionarlos antes de que afecten negativamente a tus resultados.'
export const ARTICLE_SUMMARY_FR: string =
  "En matière de musique d'ambiance pour les entreprises, l'important n'est pas ce que vous proposez, mais ce que vous diffusez. Pourtant, la grande majorité des entreprises commettent des erreurs cruciales qui leur coûtent des clients, des revenus et, dans certains cas, des dizaines de milliers d'euros d'amendes. Dans cet article, nous analysons les cinq erreurs les plus coûteuses en matière de playlists musicales pour les entreprises et expliquons comment les corriger avant qu'elles n'impactent négativement votre chiffre d'affaires."
export const ARTICLE_SUMMARY_KO: string =
  '사업장에서 음악을 사용하는 데 있어 중요한 것은 어떤 음악을 틀어주느냐이지, 어떤 음악을 제공하느냐가 아닙니다. 하지만 대다수의 기업들이 치명적인 실수를 저지르며 고객과 수익을 잃고, 심지어 수만 달러에 달하는 법적 벌금을 물기도 합니다. 이 글에서는 기업들이 저지르는 가장 흔하고 비용이 많이 드는 다섯 가지 음악 재생 목록 관련 실수를 분석하고, 이러한 실수가 기업의 수익에 악영향을 미치기 전에 어떻게 해결할 수 있는지 살펴보겠습니다.'

export const FIVE_MISTAKES_ARTICLE_PUBLISHED_STR: string = '2025-12-24'
export const FIVE_MISTAKES_ARTICLE_CREATED_STR: string = '2025-12-24'
export const FIVE_MISTAKES_ARTICLE_PUBLISHED: Date = new Date(
  FIVE_MISTAKES_ARTICLE_PUBLISHED_STR
)
export const FIVE_MISTAKES_ARTICLE_CREATED: Date = new Date(
  FIVE_MISTAKES_ARTICLE_CREATED_STR
)
